<div class="lock-camera">
  <div [matTooltip]="'MAP.LOCK_CAMERA' | translate" (click)="lock()" *ngIf="!mapComp.cameraLocked">
    <fa-icon icon="lock-open" size="2x"></fa-icon>
  </div>
  <div mat-raised-button [matTooltip]="'MAP.UNLOCK_CAMERA' | translate" (click)="unlock()" *ngIf="mapComp.cameraLocked">
    <fa-icon icon="lock" size="2x"></fa-icon>
  </div>

</div>
